import {useAuth} from '@clerk/react'
import {Navigate, Outlet} from 'react-router-dom'
import {LayoutSplashScreen} from '../../_metronic/layout/core'

const RequireAuth = () => {
  const {isLoaded, isSignedIn} = useAuth()

  if (!isLoaded) {
    return <LayoutSplashScreen />
  }

  if (!isSignedIn) {
    return <Navigate to='/auth' replace />
  }

  return <Outlet />
}

export default RequireAuth
